import UnitDrawerQuizArchetypesTable from './IndividualUnitDrawerQuizArchetypesTable';

export default UnitDrawerQuizArchetypesTable;
